const actions = {
    adminBlockSumAccount({ commit, dispatch }, { id, sum, comment }) {
        return axios
            .post(`/operator-buhgalter/profiles/${id}/accounts/block`, {
                summ: sum,
                comment: comment,
            })
            .then(res => {
                dispatch('operatorBuhgalterFetchAccounts', id)
            })
    },

    adminUnblockSumAccount({ commit, dispatch }, { id, sum, comment }) {
        return axios
            .post(`/operator-buhgalter/profiles/${id}/accounts/unblock`, {
                summ: sum,
                comment: comment,
            })
            .then(res => {
                dispatch('operatorBuhgalterFetchAccounts', id)
            })
    },

    adminWithdrawToEtpAccount({ commit, dispatch }, { id, sum, comment, withdrawDebt }) {
        return axios
            .post(`/operator-buhgalter/profiles/${id}/accounts/withdrawToEtp`, {
                summ: sum,
                comment: comment,
                withdrawDebt: withdrawDebt,
            })
            .then(res => {
                dispatch('operatorBuhgalterFetchAccounts', id)
            })
    },

    adminRefillFromEtpAccount({ commit, dispatch }, { id, sum, comment }) {
        return axios
            .post(`/operator-buhgalter/profiles/${id}/accounts/refillFromEtp`, {
                summ: sum,
                comment: comment,
            })
            .then(res => {
                dispatch('operatorBuhgalterFetchAccounts', id)
            })
    },
};

export default actions;
